import { render, staticRenderFns } from "./PasswordRules.vue?vue&type=template&id=1c2c1a43&scoped=true"
import script from "./PasswordRules.vue?vue&type=script&lang=js"
export * from "./PasswordRules.vue?vue&type=script&lang=js"
import style0 from "./PasswordRules.vue?vue&type=style&index=0&id=1c2c1a43&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2c1a43",
  null
  
)

/* custom blocks */
import block0 from "./PasswordRules.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports